<template>
  <Card class="listCharactersItem">
    <div class="block">
      <h2 class="characterTitle title is-4">{{ character.name }}</h2>
      <p class="classRaceSubtitle subtitle is-6">{{ [ race.name, className ].join(' ') }} ({{ difficulty.name }})</p>
    </div>
    <template v-slot:footer>
      <slot />
    </template>
  </Card>
</template>

<script>
import { defineComponent } from 'vue'

import Card from '@/components/Card'

import characterComputedValues from '@/hooks/characterComputedValues'

export default defineComponent({
  props: {
    character: {
      type: Object,
      required: true
    }
  },

  components: {
    Card
  },

  setup (props) {
    const computedCharacter = characterComputedValues(props.character)

    return {
      ...computedCharacter
    }
  }
})
</script>

<style lang="sass" scoped>
.characterTitle
  font-family: 'Playfair Display', serif

.classRaceSubtitle
  text-transform: capitalize

.link
  font-weight: normal

.button
  font-family: 'Roboto', sans-serif
</style>
